export interface PecaAiOrderDetailRequest {
  document?: string;
  orderId?: string;
}

export interface PecaAiOrderPayment {
  paymentMethodName: string;
  amount: number;
  installments: number;
}

export enum PecaAiOrderShippingStatus {
  Pending = 'PENDING',
}

export const PecaAiOrderShippingStatusLabel: Record<
  PecaAiOrderShippingStatus,
  string
> = {
  PENDING: 'Pendente',
};

export const PecaAiOrderShippingStatusColor: Record<
  PecaAiOrderShippingStatus,
  string
> = {
  PENDING: 'blue',
};

export interface PecaAiOrderShipping {
  status: PecaAiOrderShippingStatus;
  expectedDelivery: string;
  amount: number;
  trackingCode: string;
  products: PecaAiOrderShippingProduct[];
}

export interface PecaAiOrderShippingProduct {
  description: string;
  quantity: number;
  catalogId: string;
  unitPrice: number;
  totalPrice: number;
  finalPrice: number;
  totalDiscountAmount: number;
  imageUrl: string;
}

export enum PecaAiOrderStatus {
  Canceled = 'CANCELED',
  InSeparation = 'IN_SEPARATION',
}

export const PecaAiOrderStatusLabel: Record<PecaAiOrderStatus, string> = {
  CANCELED: 'Cancelado',
  IN_SEPARATION: 'Em separação',
};

export const PecaAiOrderStatusColor: Record<PecaAiOrderStatus, string> = {
  CANCELED: 'red',
  IN_SEPARATION: 'blue',
};

export interface PecaAiOrderDetailResponse {
  id: string;
  orderNumber: string;
  commerceReference: string;
  status: PecaAiOrderStatus;
  shippingAddress: {
    zipCode: string;
    street: string;
    number: string;
    city: string;
    complement: string;
    neighborhood: string;
    state: string;
    description: string;
  };
  creationDate: string;
  finalPrice: number;
  shippingAmount: number;
  discountAmount: number;
  refundAmount: number;
  deadlineHours: number;
  invoiceObservations: string;
  payments: PecaAiOrderPayment[];
  shippings: PecaAiOrderShipping[];
  unavailableProducts: [];
}
